import { ITeam, IUser } from "apis";
import { ISelectOption } from "types";

export const buildNoTeamOption = (noSelectTeamLabel: string) => ({
  label: noSelectTeamLabel,
  value: -1,
});

export const buildPlayerOption = (
  noSelectLabel: string,
  team?: ITeam
): ISelectOption[] => {
  const noSelectOption = {
    label: noSelectLabel,
    value: -1,
  };

  if (!team || !team.users) {
    return [noSelectOption];
  }

  const options = team.users.map((user: IUser) => ({
    label: user.number > 0 ? `${user.name}(${user.number})` : user.name,
    value: user.id,
  }));
  options.unshift(noSelectOption);
  return options;
};

export const getUserFromTeam = (
  userId: number,
  users: IUser[] = []
): IUser | undefined => {
  return users.find((user) => user.id === userId);
};
